import React, { Component } from 'react';
import { Form, Icon, Input, Button, Row, Col, Spin, Select,  Checkbox } from 'antd';
const FormItem = Form.Item;
const { Option } = Select;

class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      plan:"free",
      lastName: '',
      email: '',
      password: '',
      role: 'student',
      card:{},
      subscription:{},
      loading: false,
      current_period_end:null,
      tos:true,
      status: {
        completed: false
      }
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleChange(e) {
    if(e.target.name === "tos")return this.setState({[e.target.name]: e.target.checked})
    this.setState({ [e.target.name]: e.target.value });
  }
  handleSelectChange(value) {
    this.setState({ role: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFields((err) => {
      if (!err) {
        this.props.signUp(this.state);
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Row>
        <Col
          xs={{ span: 22, offset:1 }}
          sm={{ span: 22, offset:1 }}
          md={{ span: 10, offset: 6 }}
          lg={{ span: 10, offset: 7 }}
        >
          <Spin tip="Signing Up..." spinning={this.props.loading}>
            <div className="signupcard fadeInUp animated">
              <div className="signup-body">

                <Form
                  className="signup-form"
                  onSubmit={(e) => {
                    this.handleSubmit(e);
                  }}
                >
                  <div className="xheader">
            <img src="../../img/logo.png" />

                  <h5>Create Your Free Account</h5>
                  </div>
                  <Row gutter={8}>
                      <Col span={12}>
                      <FormItem >
                    {getFieldDecorator('firstName', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your first name'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="user"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="firstName"
                        placeholder="First Name"
                      />
                    )}
                  </FormItem>
                      </Col>
                      <Col span={12}>
                      <FormItem>
                    {getFieldDecorator('lastName', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your last name'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="user"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="lastName"
                        placeholder="Last Name"
                      />
                    )}
                  </FormItem>

                      </Col>
                </Row>
                  <Form.Item >
                    {getFieldDecorator('select', {
                      initialValue:"student",
                      rules: [
                        { required: true, message: 'Please select your role!' }
                      ]
                    })(
                      <Select onChange={this.handleSelectChange} placeholder="Please select a role">
                        <Option value="student">Student</Option>
                        {/* <Option disabled value="teacher">Teacher</Option> */}
                      </Select>
                    )}
                  </Form.Item>

                  <FormItem>
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your email'
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid email'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="mail"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="email"
                        placeholder="Email"
                      />
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your password'
                        },
                        {
                          min: 6,
                          message: 'Password should be at least 6 characters'
                        }
                      ]
                    })(
                      <Input.Password
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="lock"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="password"
                        type="password"
                        placeholder="Password"
                      />
                    )}
                  </FormItem>
                  <Form.Item >
                    {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true
                    })(<Checkbox style={{fontFamily:'t-regular'}} onChange={e => this.handleChange(e)} name="tos">I agree to Terms & Conditions and Privacy Policy</Checkbox>)}
                    </Form.Item>
                  <FormItem>
                    <Button disabled={!this.state.tos} block type="primary" htmlType="submit" className="xpad-btn">
                      SIGN UP
                    </Button>
                  </FormItem>
                  <div className="signup-footer">
                <p style={{ fontSize: 16}}>
                  Already have an account? <span onClick={this.props.toggleModal}>Login</span>
                </p>
              </div>
                </Form>
              </div>
              
            </div>
          </Spin>
        </Col>
      </Row>
    );
  }
}
const WrappedSignupForm = Form.create()(Signup);
export default WrappedSignupForm;
